import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { SelectField, TextField } from 'redux-form-material-ui';
import { Field, reduxForm, SubmissionError } from 'redux-form';
import MuiChevronRight from 'material-ui/svg-icons/navigation/chevron-right';
import {
  MenuItem as MuiMenuItem,
  RaisedButton as MuiRaisedButton
} from 'material-ui';
import { Navigation } from '../../../navigation/react-redux-nav';
import { get } from 'lodash';
import { validateAddress, saveShippingAddress, setShippingAddress } from '../../../store/ducks/shipping-address';
import { redeemActivationCode, makeYearlyPayment } from '../../../store/ducks/payment';
import states from './states';
import { blueGray, blueGray30, blueGray54, solidWhite } from '../../../theme/colors';
import styles from '../../../shared-styles';
import './shipping-address-form.css';
import VerifyAddress from './verify-address-modal';
import { onboardingCompleted } from '../../../store/ducks/user';

export const validate = (values) => {
  const errors = {};
  if (!values.address1) errors.address1 = 'Required.';
  if (!values.city) errors.city = 'Required.';
  if (!values.state) errors.state = 'Required.';
  if (!values.zip) errors.zip = 'Required.';
  return errors;
};

export class ShippingAddressForm extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  submitForm = async (address) => {
    try {
      const { value } = await this.props.validateAddress(address);
      if (value.verifyLevel === 'Verified') {
        await this.saveAndContinue(address);
      } else {
        this.setState(value);
      }
    } catch (err) {
      throw new SubmissionError({ _error: err.message });
    }
  }

  handleSubmit = this.props.handleSubmit(this.submitForm);

  saveAndContinue = async (address) => {
    this.props.setShippingAddress(address);
    if (this.props.skipSubscription === true) {
      await this.props.saveShippingAddress(address);
      return this.onboardingDone();
    }
    if (this.props.activationCode) {
      await this.props.redeemActivationCode(this.props.activationCode, this.props.activationCodeItems, address);
      this.props.moveForward();
    } else {
      await this.props.saveShippingAddress(address);
      this.props.makeYearlyPayment();
    }
  }

  cancelValidation = () => {
    this.setState({ verifyLevel: null });
  }

  confirmAddress = async (address) => {
    const shippingAddress = {
      address1: address.address1,
      address2: address.address2,
      city: address.city,
      state: address.state,
      zip: address.postalCode,
    };

    await this.saveAndContinue(shippingAddress);
  }

  onboardingDone(state, dispatch) {
    onboardingCompleted();
  }

  render() {
    return (
      <div className="shipping-address-form">
        <form className= { this.props.className } onSubmit={ this.handleSubmit }>
          <Field
            autoFocus
            name="address1"
            id="shipping-address"
            component={ TextField }
            floatingLabelText="Address"
            hintText="Address"
            floatingLabelStyle={ styles.floatingTextFieldStyle }
            fullWidth={ true }
          />
          <Field
            name="city"
            id="shipping-city"
            component={ TextField }
            floatingLabelText="City"
            hintText="City"
            floatingLabelStyle={ styles.floatingTextFieldStyle }
            fullWidth={ true }
          />
          <div className="shipping-address-row">
            <div className="shipping-address-column">
              <Field
                name="state"
                id="shipping-address-state"
                component={ SelectField }
                floatingLabelText="State"
                floatingLabelStyle={ styles.floatingTextFieldStyle }
                selectedMenuItemStyle={{
                  color: blueGray,
                  fontWeight: 600
                }}
                dropDownMenuProps={{
                  menuStyle: { width: 'auto' },
                  iconButton: <MuiChevronRight />,
                  targetOrigin: {
                    vertical: 'center',
                    horizontal: 'left'
                  }
                }}
                iconStyle={{
                  transform: 'rotate(90deg)',
                  fill: blueGray54
                }}
                style={{ textAlign: 'left' }}
                maxHeight={ 400 }
                fullWidth={ true }
              >
                { states.map(state => <MuiMenuItem value={ state.abbreviation } key={ state.abbreviation } primaryText={ state.name } />) }
              </Field>
            </div>
            <div className="shipping-address-column">
              <Field
                name="zip"
                id="shipping-address-zip"
                component={ TextField }
                floatingLabelText="Zip Code"
                hintText="Zip Code"
                floatingLabelStyle={ styles.floatingTextFieldStyle }
                fullWidth={ true }
                autoCorrect="off"
              />
            </div>
          </div>
          { !this.props.submitting && this.props.error
            ? <p className="error-text" style={ styles.errorStyle }>{ this.props.error }</p>
            : null
          }
          { this.state.error
            ? <p className="error-text" style={ styles.errorStyle }>{ this.state.error }</p>
            : null
          }
          <MuiRaisedButton
            className="button"
            label="Submit"
            type="submit"
            primary={ true }
            disabled={ !this.props.valid }
            fullWidth={ true }
            style={ styles.buttonStyle }
            buttonStyle={ styles.buttonBorderStyle }
            labelStyle={ styles.buttonLabelStyle }
            disabledBackgroundColor={ blueGray30 }
            disabledLabelColor={ solidWhite }
          />
        </form>
        <VerifyAddress
          cancelValidation={ this.cancelValidation }
          onAddressVerified={ this.confirmAddress }
          verifyLevel={ this.state.verifyLevel }
          verifyAddress={ this.state.verifyAddress }
          verifyResults={ this.state.verifyResults }
          address={ this.props.addressFormValues }
          saveAndContinue={ this.saveAndContinue }
        />
      </div>
    );
  }
}

ShippingAddressForm.propTypes = {
  validateAddress: PropTypes.func.isRequired,
  valid: PropTypes.bool.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  error: PropTypes.string,
  submitting: PropTypes.bool,
  activationCode: PropTypes.string,
  activationCodeItems: PropTypes.array,
  saveShippingAddress: PropTypes.func.isRequired,
  redeemActivationCode: PropTypes.func.isRequired,
  makeYearlyPayment: PropTypes.func.isRequired,
  moveForward: PropTypes.func.isRequired,
  setShippingAddress: PropTypes.func.isRequired,
  addressFormValues: PropTypes.object,
  skipSubscription: PropTypes.bool,
  className: PropTypes.string
};

export default connect(
  state => ({
    activationCode: state.payment.activationCode,
    activationCodeItems: state.payment.activationCodeItems,
    addressFormValues: get(state.form, 'shippingAddress.values')
  }),
  dispatch => ({
    validateAddress: address => dispatch(validateAddress(address)),
    saveShippingAddress: address => dispatch(saveShippingAddress(address)),
    redeemActivationCode: async (code, items, address) => dispatch(redeemActivationCode(code, items, address)),
    makeYearlyPayment: async () => {
      await dispatch(makeYearlyPayment());
      dispatch(Navigation.forward());
    },
    moveForward: () => dispatch(Navigation.forward()),
    setShippingAddress: address => dispatch(setShippingAddress(address)),
    onboardingCompleted: () => dispatch(onboardingCompleted())
  })
)(
  reduxForm({
    form: 'shippingAddress',
    validate
  })(ShippingAddressForm)
);
